import * as React from "react";
import { nftData } from "@/data/nft-data";
import OwnerNFTCard from "@/components/atomics/owner-nft-card";
import { useNavigate, useParams } from "react-router-dom";
import { OwnerNftData } from "@/types";
import { useOwner } from "@/context/OwnerContext";
import LoadMoreButton from "@/components/atomics/load-more-button";
import { useEffect, useState } from "react";
import { useWallet } from "@/context/WalletContext";
import CollapsibleGroup from "@/components/atomics/collapsible-group";
interface OwnerNftType {
  itemsData: OwnerNftData[];
}

const limit_count = 8;
export default function OwnerNft({ itemsData }: OwnerNftType) {
  const navigate = useNavigate();
  const { isEditView, isOwnerView } = useOwner();
  const { walletAddress } = useWallet();
  const { address } = useParams();
  const [displayCount, setDisplayCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [showOwnerView, setShowOwnerView] = useState(false);

  useEffect(() => {
    setDisplayCount(Math.min(limit_count, itemsData.length));
  }, [itemsData]);

  useEffect(() => {
    if (walletAddress) {
      if (walletAddress === address) {
        setShowOwnerView(true);
      } else {
        setShowOwnerView(false);
      }
    }
  }, [walletAddress, address]);

  const handleLoadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      if (displayCount >= itemsData.length) {
        setDisplayCount(limit_count);
      } else {
        setDisplayCount(prev =>
          Math.min(prev + limit_count / 2, itemsData.length)
        );
      }
      setIsLoading(false);
    }, 300);
  };

  return (
    <CollapsibleGroup
      isEditView={isEditView}
      editTitle={isOwnerView && showOwnerView ? "MY NFT" : "WALLET NFT"}
      viewTitle={isOwnerView && showOwnerView ? "MY NFT" : "WALLET NFT"}
      className={`${itemsData.length > 0 ? "pointer-events-auto" : "pointer-events-none"}`}
      extendedViewClassName="w-full px-[30px] py-[15px] text-[30px] bg-black text-white"
      collapsedViewClassName="w-full px-[30px] py-[15px] text-[30px] bg-black text-white"
    >
      <div className="flex flex-col px-[30px]">
        <div className="w-full grid grid-cols-4 gap-[18px] transition-all duration-500 ease-in-out">
          {itemsData.slice(0, displayCount).map((item, index) => (
            <OwnerNFTCard
              key={index}
              className={`w-full flex-shrink-0 transition-all duration-300 ease-in-out hover:cursor-pointer ${
                isLoading ? "animate-pulse opacity-60" : "opacity-100"
              }`}
              onClick={() => navigate(`/nft/${item.address}`)}
              item={item}
            />
          ))}
        </div>
        {itemsData.length > limit_count && (
          <LoadMoreButton
            isLoading={isLoading}
            hasMore={displayCount < itemsData.length}
            onLoadMore={handleLoadMore}
          />
        )}
      </div>
    </CollapsibleGroup>
  );
}
